import { lazy } from 'react';

export const ModalAuthenticateClient = lazy(
  () => import('./ModalAuthenticateClient/ModalAuthenticateClient'),
);
export const ModalAuthenticate = lazy(
  () => import('./ModalAuthenticate/ModalAuthenticate'),
);
export const ModalAuthenticateLedger = lazy(
  () => import('./ModalAuthenticateLedger/ModalAuthenticateLedger'),
);
export const ModalAuthenticateSignature = lazy(
  () => import('./ModalAuthenticateSignature/ModalAuthenticateSignature'),
);
export const ModalMyDealLeaveReview = lazy(
  () => import('./ModalMyDealLeaveReview/ModalMyDealLeaveReview'),
);
export const ModalEarlyAccess = lazy(() => import('./ModalEarlyAccess/ModalEarlyAccess'));
export const ModalFilstationEarlyAccess = lazy(
  () => import('./ModalFilstationEarlyAccess/ModalFilstationEarlyAccess'),
);
export const ModalEditProfile = lazy(() => import('./ModalEditProfile/ModalEditProfile'));
export const ModalAllowance = lazy(() => import('./ModalAllowance/ModalAllowance'));
export const ModalFilesUpload = lazy(() => import('./ModalFilesUpload/ModalFilesUpload'));
export const ModalConfirmFileDelete = lazy(
  () => import('./ModalConfirmFileDelete/ModalConfirmFileDelete'),
);
export const ModalEditEmail = lazy(() => import('./ModalEditEmail/ModalEditEmail'));
export const ModalStorageProviderEditPreview = lazy(
  () => import('./ModalStorageProviderEditPreview/ModalStorageProviderEditPreview'),
);
export const ModalChangeEmailMessage = lazy(
  () => import('./ModalChangeEmailMessage/ModalChangeEmailMessage'),
);
export const ModalStorageRequest = lazy(
  () => import('./ModalStorageRequest/ModalStorageRequest'),
);
export const ModalCheckEmailMessage = lazy(
  () => import('./ModalCheckEmailMessage/ModalCheckEmailMessage'),
);
export const ModalInitialFilecoinAddressConnect = lazy(
  () => import('./ModalInitialFilecoinAddressConnect/ModalInitialFilecoinAddressConnect'),
);

export const ModalConnectedAddresses = lazy(
  () => import('./ModalConnectedAddresses/ModalConnectedAddresses'),
);

export const ModalAccountSettings = lazy(
  () => import('./ModalAccountSettings/ModalAccountSettings'),
);

export const ModalLoginRequired = lazy(
  () => import('./ModalLoginRequired/ModalLoginRequired'),
);

export const ModalDeclineStorageRequest = lazy(
  () => import('./ModalDeclineStorageRequest/ModalDeclineStorageRequest'),
);
